import { UsuarioModel } from './../model/usuario/usuario.model';
import { PermissoesService } from './../service/usuario/permissoes.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@alfresco/adf-core';
import {MatDialog} from '@angular/material/dialog';
import { IncludeUniquePermissionComponent } from 'app/include-unique-permission/include-unique-permission.component';
import { IncluirPermissaoUserComponent } from './incluir-permissao-user/incluir-permissao-user.component';

@Component({
  selector: 'app-configurar-permissoes',
  templateUrl: './configurar-permissoes.component.html',
  styleUrls: ['./configurar-permissoes.component.scss']
})
export class ConfigurarPermissoesComponent implements OnInit {
  usuarioId : number;
  usuarioRM : UsuarioModel;
  abaSelectedPos = 0;
  loading = false;
  showPermis = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private permissoesService : PermissoesService,
    private authService: AuthenticationService,
    public dialog: MatDialog

  ) {

    this.route.params.subscribe((params) => (this.usuarioId = params['id']));
    this.getUsuario();
    //console.log("oxeeeeeeeeeeee")

  }

  ngOnInit() {
  }

  getUsuario(){
    this.permissoesService.getUsuarioRM(this.usuarioId).subscribe(res=>{
      this.usuarioRM = res;
    })

  }

  removeRole(role){
    this.loading = true;
    this.permissoesService.deleteRolePermissions(role.id).subscribe(res => {
      this.getUsuario();
      this.loading = false;
     }
    )

  }

  addRole(idUsuario, idCliente, idRole){
    this.loading = true;
    let obj = { "usuarioId": idUsuario, "clienteId" : idCliente , "roleId" : idRole}
    this.permissoesService.postRoleEmpresa(obj).subscribe(res=>{
      this.getUsuario();
      this.loading = false;
    })

  }

  abaSelected(position){
    this.abaSelectedPos = position;
  }

  openPermissionUser() {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + 'px';
    } else {
      largura = innerWidth - innerWidth / 2 + 'px';
    }
    const dialogRef = this.dialog.open(IncluirPermissaoUserComponent, {
      data: { usuario : this.usuarioRM },
      width: largura
    });

    dialogRef.afterClosed().subscribe(result => {
       if(result == true){
        this.loading = true;
        this.getUsuario();
        this.loading = false;
       }
    });
  }

  openDialog(empresa) {



    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + 'px';
    } else {
      largura = innerWidth - innerWidth / 2 + 'px';
    }

    const dialogRef = this.dialog.open(IncludeUniquePermissionComponent, {
      data: { dataDialog: empresa, usuario : this.usuarioRM },
      width: largura
    });

    dialogRef.afterClosed().subscribe(result => {
       if(result == true){
        this.loading = true;
        this.getUsuario();
        this.loading = false;
       }
    });
  }

  showPermissions(){
    if(this.showPermis){
      this.showPermis = false;
    }else{
      this.showPermis = true;
    }
  }

  removerPermissionCliente(permission){

    this.loading = true;
    this.permissoesService.deleteUserPermissionEmpresa(permission).subscribe(res => {
      this.getUsuario();
      this.loading = false;
     }, error =>{
       console.log(error)
     }
    )
  }


}



// WEBPACK FOOTER //
// /app/src/app/configurar-permissoes/configurar-permissoes.component.ts